export default __webpack_public_path__ + "static/media/Redwing-Light.bda27836.otf";